<template>
  <div class="main-authentication">
    <div class="login-box box-auth">

      <img v-if="monenco" src="@/assets/images/monencogroup-logo.png" alt="logo">
      <img v-else src="@/assets/images/logo.png" alt="logo">

      <div class="title">
        <router-link to="/auth/login"><i class="fa-regular fa-arrow-right"></i> بازگشت</router-link>

        <h2>انتخاب رمز جدید</h2>
      </div>
      <form @submit.prevent="changePass">
        <div class="input input-pass">
          <label>
            گذرواژه فعلی
          </label>
          <input v-model="currentPassword" :type="showPass3 ? 'text':'password'">
          <i @click="showPass3 = !showPass3" class="fa-regular"
             :class=" !showPass3 ? 'fa-eye-slash' : 'fa-eye'"
          ></i>


        </div>
        <div class="input input-pass">
          <label>
            گذرواژه جدید
          </label>
          <input v-model="password" :type="showPass ? 'text':'password'">
          <i @click="showPass = !showPass" class="fa-regular"
             :class=" !showPass ? 'fa-eye-slash' : 'fa-eye'"
          ></i>


        </div>
        <!--      <div class="error-box text-danger">گذرواژه وارد شده اشتباه است.</div>-->
        <div class="input input-pass ">
          <label>
            تکرار گذرواژه جدید
          </label>
          <input v-model="passwordConfirmation" :type="showPass2 ? 'text':'password'">
          <i @click="showPass2 = !showPass2" class="fa-regular"
             :class=" !showPass2 ? 'fa-eye-slash' : 'fa-eye'"
          ></i>


        </div>
        <div v-if="Object.keys(errors).length > 0" class="alert w-100 alert-danger mt-3 mb-0" role="alert">
          <div v-for="(err,index) in errors" :key="index">
            <span class="text-right" v-for="(msg,i) in err" :key="i"> {{ msg }}</span>
          </div>
        </div>


        <v-btn :disabled="loading" type="submit" class="btn btn-save">تغییر رمز عبور</v-btn>
      </form>

    </div>
  </div>

</template>

<script>
import axios from "axios";
import store from "@/store";

export default {
  name: "NewPassword",
  data() {
    return {
      apiBaseUrl: window.appConfig.API_URL_BASE,
      monenco: window.appConfig.monenco,
      showPass: true,
      showPass2: true,
      showPass3: true,
      passwordConfirmation: '',
      userName: '',
      password: '',
      currentPassword: '',
      loading: false,
      errors: {},
      snackbar: false,
      textSnack: '',
      colorSnack: '',
      headers: {
        'Accept': 'Application/json',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      }
    }
  },
  methods: {

    changePass() {

      if (this.userName === '') {
        this.$router.push('/auth/login')
        return
      }
      if(this.password === '' && this.currentPassword ==='' && this.passwordConfirmation === ''){
        this.showMsg('لطفا همه موارد را وارد کنید', 'red')
        return;
      }
      if(this.password !== this.passwordConfirmation){
        this.showMsg('رمز عبور و تایید آن برابر نیست', 'red')
        return;

      }



      this.loading = true
      axios.post(this.apiBaseUrl + 'api/users/change-password',
          {
            username: this.userName,
            current_password: this.currentPassword,
            password: this.password,
            password_confirmation: this.passwordConfirmation,
          },
          {headers: this.headers})
          .then(() => {
            this.loading = false
            this.$router.push('/auth/password')
            this.errors= {}


          }).catch(err => {
        this.loading = false
        if (!err?.response) {
          this.showMsg('اینترنت خود را بررسی کرده و مجدد  تلاش کنید!', 'red')
          return
        }
        this.errors = err?.response?.data?.errors

      })

    },
    showMsg(msg, color) {
      this.$store.dispatch("snackbar/show", {
        text: msg,
        color: color
      })
    },
  },
  mounted() {
    this.userName = store.getters.getMobile
  },
}
</script>

<style scoped lang="scss">

.login-box .input input {
  text-align: right;
}

</style>
